var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('van-popup',{on:{"close":function($event){return _vm.switchOver(false)}},model:{value:(_vm.status),callback:function ($$v) {_vm.status=$$v},expression:"status"}},[_c('div',{staticClass:"code_img",attrs:{"id":"payQrcode"}})])}
var staticRenderFns = []

export { render, staticRenderFns }